import { AgreementApiClient } from 'api/AgreementApiClient'
import { Agreement } from 'model'
import { useApiCall, useApiClient } from '@hooks'
import { useEffect, useMemo } from 'react'
import { ApplicantType, ApplicationType } from 'shared'
import { agreementMatchesApplication } from 'shared/ApplicationHelper'

export default function useAgreements(dealerId: number | undefined, applicationType: ApplicationType, applicantType: ApplicantType) {
    const agreementApiClient = useApiClient(x => new AgreementApiClient(x))
    const [allAgreements, isLoadingAgreements, getAgreements] = useApiCall(agreementApiClient.getAgreements, [] as Agreement[])

    useEffect(() => {
        if(!dealerId){
            return
        }

        getAgreements(dealerId)
    }, [dealerId])

    const agreements = useMemo(
        () => allAgreements.filter(x => agreementMatchesApplication(x, applicationType, applicantType)),
        [allAgreements, applicationType, applicantType])

    return { agreements, isLoadingAgreements }
}
